import Connection from '../connection';

const BASE_PATH = '/guest';

export function resolveInvite(inviteId) {
  const URL = '/resolveInvite';
  return Connection.send(`${BASE_PATH}${URL}/${inviteId}`);
}



// WEBPACK FOOTER //
// ./src/services/api/guest.js